import { ReactNode } from 'react';
import styled from 'styled-components';
import { Link } from 'ui/links';
import { body2, colors, spacing } from 'ui/theme';

const SnippetLink = styled(Link)`
  ${body2}
  border-bottom: none;
  > svg {
    margin-bottom: -${spacing.eighth};
  }
`;

const ClickableUrl = styled.a`
  color: ${colors.cyan100};
`;

type NameProps = {
  value: ReactNode;
  snippetId?: number;
  redirect?: boolean;
};

export const Name = ({ value, snippetId, redirect }: NameProps) => {
  if (snippetId) {
    return (
      <SnippetLink href={`/templates/snippet/${snippetId}/edit`} target="_blank" hasOpenNewTabIcon>
        <span>{value}</span>
      </SnippetLink>
    );
  }

  if (redirect && (value as string).includes('http')) {
    return <ClickableUrl href={value as string}>{value}</ClickableUrl>;
  }

  return <span>{value}</span>;
};
